/**
 * Do not edit directly
 * Generated on Thu, 29 Sep 2022 18:15:25 GMT
 */

export const componentListItemContainerBackgroundColor = "#fff";
export const componentListItemLeadingMarginRight = "1rem";
export const componentListItemTextLabelAliasName = "component.text.body";
export const componentListItemTextLabelAliasOptionsSize = "medium";
export const componentListItemTitleAliasName = "component.text.body";
export const componentListItemTitleAliasOptionsSize = "large";
export const componentListItemTitleAliasOptionsWeight = 700;
export const componentListItemTrailingMarginLeft = "1rem";
export const componentListSeparatorAliasName = "component.divider.container";
export const componentListSeparatorPaddingHorizontal = 0;
export const componentListSeparatorPaddingVertical = "1rem";